import { render, staticRenderFns } from "./settingFontSize.vue?vue&type=template&id=69178036&"
import script from "./settingFontSize.vue?vue&type=script&lang=js&"
export * from "./settingFontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69178036')) {
      api.createRecord('69178036', component.options)
    } else {
      api.reload('69178036', component.options)
    }
    module.hot.accept("./settingFontSize.vue?vue&type=template&id=69178036&", function () {
      api.rerender('69178036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/settingFontSize.vue"
export default component.exports